import { Card, CardContent, CardHeader, makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  cardContent: {
    paddingTop: '50px',
    "&:last-child": {
      paddingBottom: '50px'
    }
  },
  cardHeader: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingLeft: '25px'
  }
}));

export default function DashboardCard(props) {
  const classes = useStyles();

  const { title, text } = props;

  return (
    <Card
      variant="outlined"
    >
      <CardHeader
        className={classes.cardHeader}
        title={title}
        titleTypographyProps={{ variant: 'button' }}
      />
      <CardContent className={classes.cardContent}>
        <Typography align="center" variant="h4">{text}</Typography>
      </CardContent>
    </Card>
  );
};